import Vue from "vue";
import Vuex from "vuex";

// import ProjectsModule from "../modules/projects/store";

Vue.use(Vuex);

export type State = {
    project: {};
    contest: {};
};

const store = new Vuex.Store({
    state: {
        project: Object.create({}),
        contest: Object.create({}),
    },
    mutations: {
        setProject(state, payload) {
            state.project = payload;
        },
        setContest(state, payload) {
            state.contest = payload;
        },
    },
    getters: {
        getContest(state) {
            return state.contest;
        },
        getProject(state) {
            return state.project;
        },
    },
    modules: {
        // projects: ProjectsModule,
    },
});

export default store;
